<template>
    <div>
        <div class="row">
            <div class="col-8">
                <div class="text-left section-title" style="padding: 5px;">
                    <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>

                        <span row-table-font-margins style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center;'>Properties to manage (user: {{currentUser.username}}) </span>

                        Units
                    </span>
                </div>
            </div>
            <div class="col-4 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <span style="
width: 30px;
height: 30px;
border-radius: 5px;
            background-color: #007DFC;
            color: white;
            display: inline-block;
            padding-left: 5px;
            padding-right: 5px;
            text-align: center;
            margin-right:8px;
          ">
                        <i class="fa fa-sliders-h" style="margin-top:7px;transform: rotate(-90deg);" aria-hidden="true"></i>
                    </span>

                    <span @click="showSearch()"
                          style="
                          width: 30px;
                          height: 30px;
                          border-radius: 5px;
                          background-color: #007DFC;
                          color: white;
                          display: inline-block;
                          padding-left: 5px;
                          padding-right: 5px;
                          text-align: center;
                          cursor:pointer;

                          ">
                        <i class="fa fa-search" style="margin-top:7px;" aria-hidden="true"></i>
                    </span>
                    <input type="text" v-if="visibleSearch" class="form-control" name="searchText" id="searchText" style=" display: inline-block; width: 250px; height: 30px;" v-model="filter">
                    <userMenu />
                </div>
            </div>

        </div>




        <div class="table-responsive">
            <table class="table table-condensed ">
                <thead>
                    <tr>
                        <th scope="col">Building Name</th>
                        <th scope="col">Floor / Number</th>
                        <th scope="col">Type</th>
                        <th scope="col">Square Meters</th>
                        <th scope="col">Monthly Fee</th>
                        <th scope="col">Balance</th>
                        <th scope="col">Email</th>
                        <th scope="col">Phone Number</th>

                        <!-- <th colspan="4" class="text-center">Actions</th>-->
                    </tr>
                </thead>
                <tbody>
                    <template v-for="property, key in paginatedData">
                        <tr class="clickable-row">

                            <td scope="row" class="clickable-column"><router-link :to="{ name: 'revenuesowner', params:{propertyId:property.id, propertyName:property.propertyName, property:property}}"> {{property.buildingName}}</router-link></td>

                            <td class="clickable-column"><router-link :to="{ name: 'revenuesowner', params:{propertyId:property.id, propertyName:property.propertyName, property:property}}"> {{ property.floor}} / {{ property.number }}</router-link></td>

                            <td scope="row" class="clickable-column"><router-link :to="{ name: 'revenuesowner', params:{propertyId:property.id, propertyName:property.propertyName, property:property}}"> {{ property.typeName}}</router-link></td>

                            <td class="clickable-column"><router-link :to="{ name: 'revenuesowner', params:{propertyId:property.id, propertyName:property.propertyName, property:property}}"> {{ property.squareMeters}}</router-link></td>

                            <td class="clickable-column"><router-link :to="{ name: 'revenuesowner', params:{propertyId:property.id, propertyName:property.propertyName, property:property}}"> {{ $filters.toCurrency(property.monthlyFee) }}</router-link></td>

                            <td class="clickable-column"><router-link :to="{ name: 'revenuesowner', params:{propertyId:property.id, propertyName:property.propertyName, property:property}}"> {{ $filters.toCurrency(property.balance) }}</router-link></td>

                            <td class="clickable-column" v-if="property.contact"><router-link :to="{ name: 'revenuesowner', params:{propertyId:property.id, propertyName:property.propertyName, property:property}}"> {{property.contact.email}}</router-link></td>

                            <td class="clickable-column" v-else><router-link :to="{ name: 'revenuesowner', params:{propertyId:property.id, propertyName:property.propertyName, property:property}}"> </router-link></td>

                            <td class="clickable-column" v-if="property.contact">
                                <router-link :to="{ name: 'revenuesowner', params:{propertyId:property.id, propertyName:property.propertyName, property:property}}"> {{property.contact.phoneNumber}}</router-link>
                            </td>

                            <td class="clickable-column" v-else><router-link :to="{ name: 'revenuesowner', params:{propertyId:property.id, propertyName:property.propertyName, property:property}}"> </router-link></td>

                        </tr>

                    </template>
                </tbody>
            </table>
        </div>
        <div class="row">
            <div class="col-8 table-summary">
                <span>  Showing {{startEntry}} to {{endEntry}} of {{numberOfEntries}} entries </span>
            </div>
            <div class="col-4">
                <paginate :page-count="numberOfPages"
                          :page-range="3"
                          :margin-pages="2"
                          :click-handler="clickCallback"
                          :prev-text="'<'"
                          :next-text="'>'"
                          :container-class="'pagination'"
                          :page-class="'page-item'">
                </paginate>
            </div>
        </div>

        <div class="clearfix"> </div>
    </div>
</template>


<script>
    import { EventBus } from '@/events';
    import { authenticationService } from '@/_services';
    import { mapState } from "vuex";
    export default {
        data: function () {
            return {
                filter: '',
                properties: [],
                contacts: [],
                //numberOfAllowedBuildings : 0,
                role: '',
                buildingId: 0,
                buildingName: '',
                pageNumber: 0,
                buttonsVisible: false,
                currentUser: null,
                visibleSearch: false,
            }
        },
        props: {
            size: {
                type: Number,
                required: false,
                default: 10
            },
            sortBy: {
                type: String,
                required: false,
                default: 'Name'
            }
        },
        watch: {
            value(val) {
                this.$emit('update:buildingId', val);

            },
            buildingId(val) {
                this.value = val;
                this.fetchStatement();
            }
        },
        created() {
            authenticationService.currentUser.subscribe(x => this.currentUser = x);
        },
        mounted() {

            //  this.buildingId = this.$route.params.buildingId;
            this.buildingId = this.$route.params.buildingId;
            this.emitGlobalClickEvent();
            this.buildingName = this.$route.params.buildingName;
            //this.$data.buildingId = this.buildingId;

            this.fetchStatement();
        },

        methods: {
            showSearch() {
                this.visibleSearch = !this.visibleSearch;
            },
            selectProperty(property) {
                property.isSelected = !property.isSelected
            },
            emitGlobalClickEvent() {

                // Send the event on a channel (i-got-clicked) with a payload (the click count.)
                EventBus.$emit('updated', this.buildingId);
            },
            fetchStatement: function () {
                this.mute = true;
                //this.buildingId = 3;
                var request = '/properties/owner?id=' + this.currentUser.id;
                this.$http.get(request, {
                    id: this.currentUser.id
                }).then(({ data }) => {
                    this.mute = false;
                    //this.contacts = data.contacts;
                    this.properties = data;

                });
            },


            /**
             * Prepare the component.
             */
            del() {
                this.$emit('delete', this.id);
            },
            clickCallback(pageNum) {
                this.pageNumber = pageNum - 1
            },
            deleteItem: function destroy(item) {
                var r = confirm("Are you sure you want to delete property?");
                if (r == true) {
                    var _this = this;
                    this.axios.delete('/properties/' + item.id).then(function () {
                        _this.fetchStatement();
                        // _this.getVueItems();
                        //_this.hasDeleted = false
                    });
                }
            }
        },

        
        computed: {
            ...mapState({
      building: (state) => state.building.currentBuilding,
      property:(state)=>state.property.currentProperty,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    propertyName(){
        if(this.property != null)
            return this.property.propertyName;
        return ""
    },
            getProperties() {
                if (!this.properties)
                    return null;
                var properties = this.properties.filter((property) => {

                    return property.propertyName.toLowerCase().includes(this.filter.toLowerCase());
                });

                return properties;

            },

            numberOfEntries() {
                return this.getProperties.length
            },
            numberOfPages() {
                let l = this.numberOfEntries,
                    s = this.size;
                return Math.ceil(l / s);
            },
            startEntry() {
                if (this.numberOfEntries == 0) {
                    return 0
                } if (this.pageNumber + 1 == 1) {
                    return 1
                } else {
                    return this.pageNumber * this.size + 1
                }
            },
            endEntry() {
                if (this.numberOfEntries <= this.size) {
                    return this.numberOfEntries
                } else if (this.numberOfEntries > this.size && (this.pageNumber + 1) == 1) {
                    return this.size
                } else if (this.numberOfEntries > this.size && (this.pageNumber + 1) > 1) {
                    if (this.numberOfEntries - (this.size * (this.pageNumber + 1)) > 0) {
                        return this.size * (this.pageNumber + 1)
                    } else {
                        return this.numberOfEntries
                    }
                } else {
                    return NaN
                }
            },

            paginatedData() {
                const start = this.pageNumber * this.size,
                    end = start + this.size;
      var sorted = [...this.getProperties];

                if (this.sortBy == 'Name') {
                    sorted.sort((a, b) => (a.buildingName.toLowerCase() > b.buildingName.toLowerCase()) ? 1 : ((b.buildingName.toLowerCase() > a.buildingName.toLowerCase()) ? -1 : 0));
                }
                else if (this.sortBy == 'Floor') {
                    sorted.sort((a, b) => (a.propertyName.toLowerCase() > b.propertyName.toLowerCase()) ? 1 : ((b.propertyName.toLowerCase() > a.propertyName.toLowerCase()) ? -1 : 0));
                }
                else {
                    sorted.sort((a, b) => (a.typeName.toLowerCase() > b.typeName.toLowerCase()) ? 1 : ((b.typeName.toLowerCase() > a.typeName.toLowerCase()) ? -1 : 0));
                }
                return sorted
                    .slice(start, end);
            }
        }

    }                // Our Javascript logic
</script>
